import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import LawyersCard from './LawyersCard';

const DraggableLawyersCard = ({ item, index, id, order_number, moveCard, data, delet, onOrderUpdate }) => {
    const ref = React.useRef(null);

    const [{ isDragging }, drag] = useDrag({
        type: "pet",
        item: { index, id, order_number },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const [, drop] = useDrop({
        accept: "pet",
        drop: (draggedItem) => {
            if (draggedItem.index !== index) {
                moveCard(draggedItem.index, index, draggedItem, item);
                draggedItem.index = index;
            }
        },
    });

    drag(drop(ref));

    return (
        <div ref={ref} style={{ opacity: isDragging ? 0.5 : 1 }}>
            <LawyersCard 
                data={item} 
                page={"team"} 
                alldata={data} 
                deleted={() => delet(item)}
                index={index}
                order_number={order_number}
                onOrderUpdate={onOrderUpdate}
            />
        </div>
    );
};

export default DraggableLawyersCard;
